import Vue from 'vue';
import App from './App.vue';
import Router from './router/index';
import "@/router/guards/Permission";
import "@/router/guards/Title";

import Buefy from 'buefy'

import './assets/scss/main.scss';
import Store from '@/store/index';
import makeModalLarge from "@/mixins/LargeModal";
import VueCookies from "vue-cookies";
import {EmojiPickerPlugin} from 'vue-emoji-picker';
import {library} from '@fortawesome/fontawesome-svg-core';
import {
    faAlignJustify,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faArrowsAlt,
    faBell,
    faBookOpen,
    faCalendar,
    faCalendarAlt,
    faCheck,
    faChevronDown,
    faChevronUp,
    faCircle,
    faClipboardCheck,
    faClipboardList,
    faClock,
    faColumns,
    faEdit,
    faEllipsisV,
    faExclamationCircle,
    faExpandArrowsAlt,
    faFile,
    faFileArchive,
    faFileAudio,
    faFileCsv,
    faFileImage,
    faFilePdf,
    faFilePowerpoint,
    faFileVideo,
    faFileWord,
    faFilter,
    faFolder,
    faFolderOpen,
    faHdd,
    faLayerGroup,
    faLink,
    faMinus,
    faMinusCircle,
    faPaintBrush,
    faPhone,
    faPlus,
    faPlusSquare,
    faSearch,
    faTrash,
    faTrophy,
    faUser,
    faUserCircle,
    faUserFriends,
    faUsers
} from '@fortawesome/free-solid-svg-icons';
import {faSkype, faWhatsapp,} from '@fortawesome/free-brands-svg-icons';
import {
    faFile as farFile,
    faFolder as farFolder,
    faPaperPlane as farPaperPlane,
    faSave as farSave,
} from '@fortawesome/free-regular-svg-icons'
import axios from 'axios'
import moment from 'moment-timezone'

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

import VueTippy from 'vue-tippy';
import vmodal from 'vue-js-modal';
import VueUpload from "./plugins/VueUpload.js";
import ChatFileLoader from './components/chat/ChatFileLoader';
import VueUploadComponent from './components/Vue-Upload';
import VueSweetalert2 from 'vue-sweetalert2';
import GenexHelperMixins from "@/mixins/GenexHelperMixins";
import MatchFilters from "@/mixins/MatchFilters";
import mixpanel from "mixpanel-browser";
import track from "@/mixins/Tracking";
import resetTracking from "@/mixins/Tracking";
import SvgIcon from '@/components/icons/SvgIcon'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import i18n from '@/icons/index'
import vueDebounce from 'vue-debounce'
import {VueErrorHandler} from "@/plugins/VueErrorHandler";
import PermissionMixin from "@/mixins/PermissionMixin";
import OldMixin from "@/mixins/OldMixin";
import "@mdi/font/css/materialdesignicons.css";
import "froala-editor/js/plugins.pkgd.min.js";
//Import third party plugins
import "froala-editor/js/third_party/embedly.min";
import "froala-editor/js/third_party/font_awesome.min";
import "froala-editor/js/third_party/image_tui.min";
// Import Froala Editor css files.
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.min.css";

import VueFroala from "vue-froala-wysiwyg";
import VueMathjax from "vue-mathjax";

Vue.use(VueFroala);

Vue.use(VueMathjax);


Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment.utc(String(value)).format('HH:mm')
    }
});


Vue.use(VueCookies);
Vue.use(VueErrorHandler)

Vue.mixin(makeModalLarge);
Vue.mixin(track);
Vue.mixin(resetTracking);
Vue.mixin(GenexHelperMixins);
Vue.mixin(MatchFilters);
Vue.mixin(PermissionMixin);
Vue.mixin(OldMixin)

mixpanel.init(process.env.VUE_APP_MIXPANEL_PROJECT_TOKEN, {debug: false});
mixpanel.register({
    Platform: GenexHelperMixins.methods.isMobileMixin ? "Mobile" : "Web",
});


Vue.use(vmodal);
Vue.use(VueTippy);
Vue.use(VueUpload);
Vue.use(VueSweetalert2);

Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;

library.add(
    faPhone,
    faHdd,
    faClipboardList,
    faUserFriends,
    faPaintBrush,
    faLayerGroup,
    faTrash,
    faPlus,
    faMinus,
    faTrophy,
    faUser,
    faAngleDown,
    faAngleRight,
    faBookOpen,
    faClock,
    faWhatsapp, farFolder, faClipboardCheck,
    faFolder,
    farFile,
    faFolderOpen,
    faFilePdf,
    faFileWord,
    faFilePowerpoint,
    faFileCsv,
    faFileImage,
    faFileArchive,
    faFileAudio,
    faFileVideo,
    faFile,
    farFile,
    farSave,
    farPaperPlane,
    faPlusSquare,
    faMinusCircle,
    faEdit, faArrowsAlt, faBell, faSearch,
    faSkype, faCalendarAlt, faBell, faUserCircle, faEllipsisV, faExpandArrowsAlt, faUsers, faLink, faAlignJustify, faCircle, faChevronDown, faChevronUp, faExclamationCircle, faCheck, faFilter, faCalendar, faAngleLeft, faColumns
);


Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(Buefy,
    {
        defaultIconPack: null,
        defaultIconComponent: SvgIcon
    }
)

Vue.use(CKEditor);

Vue.$cookies.config(-1, '', '')

Vue.component('ChatFileLoader', ChatFileLoader);
Vue.component('UploadComponent', VueUploadComponent);
Vue.use(EmojiPickerPlugin);

Vue.use(vueDebounce, {
    defaultTime: '300ms'
})
Vue.config.productionTip = false;

// redirect all unauthorized requests to login page
axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        if (error.response.status === 401) {
          if (window.location.pathname !== "/login") {
            window.location.href = "/login";
          }
        } 
      }
      return Promise.reject(error);
    }
  );

export default new Vue({
    router: Router,
    store: Store,
    i18n,
    async mounted() {
        await Store.dispatch('loader/show', 'Welcome back....');
    },
    render: h => h(App),

}).$mount('#app');
